module.exports = __webpack_public_path__ + "img/left_1.72810d41.jpg";